import React from 'react';
import { clsx } from 'clsx';
import Icon from '../../1-molecules/Icon/Icon';
import styles from './Tag.module.css';

/**
 * A small, self-contained Tag atom for displaying preference matches.
 *
 * @param {object} props
 * @param {'positive' | 'negative' | 'neutral'} props.variant - The visual style of the tag.
 * @param {string} props.text - The text to display inside the tag.
 * @param {string} [props.className] - Optional additional class for the wrapper.
 */
const Tag = ({ variant, text, className }) => {
  const tagClasses = clsx(styles.tag, styles[variant], className);

  // Determine which icon to use based on the variant
  const iconName = {
    positive: 'check',
    negative: 'close',
  }[variant];

  return (
    <div className={tagClasses}>
      {/* For positive/negative, render the icon in its container */}
      {(variant === 'positive' || variant === 'negative') && (
        <div className={styles.iconContainer}>
          <Icon name={iconName} size="xs" />
        </div>
      )}

      {/* For neutral, render the simple dot */}
      {variant === 'neutral' && <div className={styles.neutralDot} />}

      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default Tag;